import React, { useState } from 'react';
import cn from 'classnames';
import titleStyles from 'app/styles/modules/title.module.less';
import homeStyles from '@app/shop/index.module.less';
import styles from './index.module.less';
import { IFeatureProdctListTabs } from 'mod/feature/interface';
import { scrollToAnchor } from 'base/utils/scrollTo';
import { ProductList } from './ProductList';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getModuleCode, getModuleElementId, getWrapStyle } from 'base/utils/features';
import ModuleTitle from '@base/lib/ModuleTitle';
import { displayCtr, loadMonkeyProducts, trackElement } from 'base/utils/tracker';
import Tracker, { autoTrackImp } from '@base/lib/Tracker';
import { ThemeSwiper } from '@base/lib/ThemeSwiper';

type IProps = {
    data: IFeatureProdctListTabs;
};

const ProdctListTabs: React.FC<IProps> = ({ data }) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    if (!data.lists.length) {
        return null;
    }

    const activeList = data.lists[activeIndex];
    const moduleCode = getModuleCode(data);
    const moduleElementId = getModuleElementId(data);

    const handleNavClick = (index: number, listTitle: string) => {
        setActiveIndex(index);

        scrollToAnchor({
            selector: '#js-tabs-nav',
            offset: -1,
        });

        displayCtr(moduleCode);
        loadMonkeyProducts();
    };

    return !data.lists.length ? null : (
        <div
            id={moduleElementId}
            data-t-mod={moduleCode}
            className={homeStyles.wrapper}
            style={getWrapStyle(data)}
        >
            <ModuleTitle
                className={cn(titleStyles.title, homeStyles.title)}
                text={data.title}
                link={data.readMoreLink}
                linkText={data.readMoreTitle}
            />

            <ThemeSwiper
                className={styles.nav}
                list={data.lists}
                slidesPerView="auto"
                slidesPerGroupAuto
                spaceBetween={30}
                onSlideChangeTransitionEnd={()=>{
                    autoTrackImp();
                }}
                render={(item, index) => (
                    <Tracker data={{
                        targetType: 'menu',
                        target: item.listTitle,
                        relTarget: item.listTitle,
                        module: moduleCode,
                        position: index + 1,
                    }}>
                        <div
                            className={cn(
                                'g-nav-item',
                                styles['nav-item'],
                                { [styles.active]: activeIndex === index }
                            )}
                            onClick={() => handleNavClick(index, item.listTitle)}
                        >
                            {item.listTitle}
                        </div>
                    </Tracker>
                )}
            />

            <ProductList
                key={activeList.listSn}
                activeIndex={activeIndex}
                listSn={activeList.listSn}
                listUrl={activeList.listUrl}
                moduleCode={moduleCode}
            />
        </div>
    )
};

export default React.memo(ProdctListTabs);
